import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { PreviewRecipient } from '@/lib/whatsappPreview';

// Who the preview resolves its {{n}} against.
//
// A SAMPLE, not an audience picker — that is the control above it. The distinction matters because
// the two answer different questions: "who receives this" and "what does it look like for one of
// them". Conflating them would make choosing a preview subject silently change who gets messaged.

interface PreviewRecipientSelectProps {
  recipients: PreviewRecipient[];
  value: string;
  onChange: (id: string) => void;
}

export const PreviewRecipientSelect = ({ recipients, value, onChange }: PreviewRecipientSelectProps) => {
  if (recipients.length === 0) {
    return (
      <p className="text-xs text-muted-foreground">
        No contacts yet — showing the template's placeholders.
      </p>
    );
  }

  return (
    <div className="flex items-center gap-2">
      <span className="whitespace-nowrap text-xs text-muted-foreground">Preview as</span>
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger className="h-8 text-xs">
          <SelectValue placeholder="Pick a contact" />
        </SelectTrigger>
        <SelectContent>
          {recipients.map((recipient) => (
            <SelectItem key={recipient.id} value={recipient.id}>
              {recipient.name || recipient.phone || 'Unnamed contact'}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default PreviewRecipientSelect;
